import { createRootRoute, Link, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import { Stage } from '@/lib/stage'

import { AppSidebar } from "@/components/shell/sidebar"
import { Toaster } from "@/components/ui/sonner"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import { Separator } from "@/components/ui/separator"
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar"
import {
  QueryClient,
  QueryClientProvider,

} from '@tanstack/react-query'
import { store } from '@/state/breadcrumb-store'
import { useSelector } from '@xstate/store/react'

import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from '@azure/msal-browser'
const queryClient = new QueryClient()

export const Route = createRootRoute({
  component: () => (
    <>
      <App></App>
    </>
  )
})

const getCurrentStage = (): Stage => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost') {
    return 'local';
  } else if (hostname === 'app.uhp-devl.umbcloud.ch') {
    return 'dev';
  } else if (hostname === 'app.uhp-intg.umbcloud.ch') {
    return 'int';
  } else if (hostname === 'app.uhp.umbcloud.ch') {
    return 'prod';
  } else {
    return 'local';
  }
}

const App = () => {
  const path = useSelector(store, (state) => state.context.path);
  const stage = getCurrentStage()

  return (
    <>

      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}  >
        <QueryClientProvider client={queryClient}>
          <Toaster />
          <SidebarProvider>
            <AppSidebar stage={stage} />
            <SidebarInset>
              <header className="flex h-16 shrink-0 items-center gap-2 border-b">
                <div className="flex items-center gap-2 px-3">
                  <SidebarTrigger />
                  <Separator orientation="vertical" className="mr-2 h-4" />
                  <Breadcrumb>
                    <BreadcrumbList>

                      {path.map((item, index) => (
                        <>

                          <BreadcrumbItem className="hidden md:block">
                            <Link to={item.to} params={item.params}>
                              {item.label}
                            </Link>

                          </BreadcrumbItem>
                          {index < path.length - 1 && (
                            <BreadcrumbSeparator className="hidden md:block" />
                          )}

                        </>
                      ))}


                    </BreadcrumbList>
                  </Breadcrumb>
                </div>
                <div className="flex items-center flex-1 justify-end m-6">

                  <img src="/UMB.svg" className="h-8" width="50" height="50"/>
                </div>

              </header>
              <div className="flex flex-1 flex-col gap-4 p-4">
                <Outlet />
                <TanStackRouterDevtools />
              </div>
            </SidebarInset>
          </SidebarProvider>
        </QueryClientProvider>
      </MsalAuthenticationTemplate>

    </>
  )
}

